import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useAdminPermissionCheck = () => {

    const { current_admin_user } = useSelector(state => ({
        current_admin_user: state.LoginAdminUser.current_user
    }))

    const adminPermissionPresent = useCallback((feature_id) => {
        return !!current_admin_user?.admin_role?.admin_permissions?.find(permission => permission?.admin_feature_id === feature_id && permission?.active);
    }, [current_admin_user])

    const allAdminPermissionsPresent = useCallback((feature_ids) => {
        feature_ids.forEach(feature_id => {
            if (!(adminPermissionPresent(feature_id))) {
                return false;
            }
        })
        return true;
    }, [current_admin_user])

    const atLeastOneAdminPermissionPresent = useCallback((feature_ids) => {
        feature_ids.forEach(feature_id => {
            if (adminPermissionPresent(feature_id)) {
                return true;
            }
        })
        return false;
    }, [current_admin_user])

    return [adminPermissionPresent, allAdminPermissionsPresent, atLeastOneAdminPermissionPresent];
}

export default useAdminPermissionCheck;